import $ from 'jquery';

export function youtubeVideo() {
    const videoItem = $('.youtube-slider__file');

    videoItem.on('click', function(){
        const _self = this;

        const dataYoutube = $(_self).attr('data-youtube');

        _self.insertAdjacentHTML('afterbegin', `<iframe class="review-slider__iframe" src="https://www.youtube.com/embed/${dataYoutube}?autoplay=1&enablejsapi=1" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"></iframe>`);
    })
}


// WEBPACK FOOTER //
// app/scripts/components/youtube.js